import firebase from "@firebase/app"
require("firebase/firestore")
require('firebase/auth')
require('firebase/storage')
import obtener_periodo from './Helper'
let config = {
  apiKey: "AIzaSyDGlw4xEWBvVM3TbrFRdxXLJwzhuSYajPU",
  authDomain: "sistema-multialmacen.firebaseapp.com",
  databaseURL: "https://sistema-multialmacen.firebaseio.com",
  projectId: "sistema-multialmacen",
  storageBucket: "sistema-multialmacen.appspot.com",
  messagingSenderId: "352667703549",
  appId: "1:352667703549:web:e5cd601a7f795c58",
  name: 'main',
  slug: 'main'
}

let _firestore, Coleccion_trabajadores, colleccion_documentos, driverCollection, coleccion_salidas, numeración_de_documentos, Motivos_de_traslado, processSalesCollection, mainAuth, db, fb, customAuth, displayName, rolesCollection, usersCollection, typeProductsCollection, productsCollection, warehouseCollection, numerationCollection, suppliersCollection, documentsCollection, OperationsCollection, clientsCollection, PrivilegesCollection, documentsOperationsCollection, processOperationsCollection, kardexCollection, customersCollection, measureUnitCollection, mainApp, storage, credential, _storage,PaymentsMethodsCollection,CurrencyCollection, documentTypesCollection, salesCollection, transportistaCollection, coleccion_cotizaciones, processCotizacionesCollection, coleccion_correo_remitente, coleccion_partidas_contables, coleccion_movimientos_contables, coleccion_naturaleza_contable, coleccion_credenciales, numeracion_de_documentos, coleccion_entradas, coleccion_entradas_a_procesar, coleccion_de_periodo_contable, coleccion_de_libro_diario, coleccion_arreglos,  coleccion_lista_compras,  coleccion_ordenes_de_compra, coleccion_salidas_emitir_comprobante, coleccion_salidas_emitir_guia, Coleccion_cotizacion_provedores
let coleccion_saldo_inicial
let appsList = []

const generateBd = config => new Promise( (resolve, reject) => {
  try{

    if (appsList.indexOf(config.slug)==-1){
      appsList.push(config.slug)
      appsList[config.slug] = firebase.initializeApp(config, config.slug)
    } 
    //CONECTION LIST OF MAIN
    let mainDb = appsList['main'].firestore()
    mainAuth = appsList['main'].auth()
    PrivilegesCollection = mainDb.collection('app').doc('setting').collection('Privileges')
    customersCollection = mainDb.collection('app').doc('setting').collection('Customers')
    usersCollection = mainDb.collection('app').doc('setting').collection('Users')
    documentTypesCollection = mainDb.collection('app').doc('setting').collection('DocumentsTypes')
    PaymentsMethodsCollection=mainDb.collection('app').doc('setting').collection('MetodosDePago')
    CurrencyCollection=mainDb.collection('app').doc('setting').collection('TipoDeMoneda')
    Motivos_de_traslado = mainDb.collection('app').doc('configuraciones').collection('motivos de traslado')
    //CONECTION LIST OF CUSTOM
    db = appsList[config.slug].firestore()
    fb = appsList[config.slug]
    _firestore = firebase.firestore
    customAuth = appsList[config.slug].auth()
    credential = firebase.auth.EmailAuthProvider.credential
    storage = appsList[config.slug].storage()
    _storage = appsList[config.slug].storage
    rolesCollection = db.collection('app').doc('setting').collection('Roles')
    typeProductsCollection = db.collection('app').doc('configuraciones').collection('Codigo de Producto')
    productsCollection = db.collection('app').doc('setting').collection('Products')
    warehouseCollection = db.collection('app').doc('setting').collection('Warehouse')
    suppliersCollection = db.collection('app').doc('setting').collection('Suppliers')
    documentsCollection = db.collection('app').doc('setting').collection('Documents')
    OperationsCollection = db.collection('app').doc('setting').collection('OutputMotive')
    clientsCollection = db.collection('app').doc('setting').collection('Clients')
    driverCollection = db.collection('app').doc('setting').collection('Conductores')
    coleccion_credenciales = db.collection('app').doc('setting').collection('Credenciales')
    
    transportistaCollection = db.collection('app').doc('setting').collection('Transportista')
    measureUnitCollection = db.collection('app').doc('setting').collection('MeasureUnit')
    coleccion_partidas_contables = db.collection('app').doc('setting').collection('partidasContables')
    coleccion_correo_remitente = db.collection('app').doc('configuraciones').collection('correo_remitente')
    Coleccion_trabajadores = db.collection('app').doc('configuraciones').collection('Trabajadores')
    coleccion_arreglos = db.collection('app').doc('configuraciones').collection('Arreglos')

    numeracion_de_documentos = db.collection('app').doc('numeracion_de_documentos')
    
    kardexCollection = db.collection('app').doc('kardex').collection('registro')
    
    salesCollection = db.collection('app').doc('ventas').collection('registro')
    processSalesCollection = db.collection('app').doc('ventas').collection('lista_a_emitir')
    
    coleccion_entradas = db.collection('app').doc('entradas').collection('registro')
    coleccion_entradas_a_procesar = db.collection('app').doc('entradas').collection('lista_a_procesar')


    coleccion_partidas_contables = db.collection('app').doc('contable').collection('partidas_contables')
    coleccion_movimientos_contables = db.collection('app').doc('contable').collection('reglas_contables')
    coleccion_de_libro_diario= db.collection('app').doc('contable').collection('libro_diario')
    coleccion_de_periodo_contable=db.collection('app').doc('contable').collection('periodo_contable')
    coleccion_saldo_inicial= db.collection('app').doc('contable').collection('saldo_inicial')

    
    coleccion_salidas = db.collection('app').doc('salidas').collection('registro')
    numeracion_de_documentos = db.collection('app').doc('numeracion_de_documentos')
    processCotizacionesCollection = db.collection('app').doc('cotizaciones').collection('process')
    coleccion_cotizaciones = db.collection('app').doc('cotizaciones').collection('cotizaciones')
    coleccion_correo_remitente = db.collection('app').doc('correo remitente').collection('correo_remitente')
    coleccion_naturaleza_contable = db.collection('app').doc('naturaleza contable').collection('naturaleza contable')

    coleccion_cotizaciones = db.collection('app').doc('cotizaciones').collection('registro')
    coleccion_lista_compras = db.collection('app').doc('cotizaciones').collection('lista_de_compras')
    coleccion_ordenes_de_compra = db.collection('app').doc('cotizaciones').collection('ordenes_de_compra')
    Coleccion_cotizacion_provedores = db.collection('app').doc('cotizaciones').collection('proveedores')
    
    coleccion_salidas = db.collection('app').doc('salidas').collection('registro')
    coleccion_salidas_emitir_comprobante = db.collection('app').doc('salidas').collection('comprobantes')
    coleccion_salidas_emitir_guia = db.collection('app').doc('salidas').collection('guias')
    colleccion_documentos = db.collection('app').doc('documentos').collection('registro')
    numeración_de_documentos = db.collection('app').doc('numeracion_de_documentos')
    
    resolve(customAuth) 
  } catch (error ){
    reject(error)
  }
})
generateBd(config)
export {
  mainAuth,
  db,
  fb,
  customAuth,
  credential,
  displayName,
  rolesCollection,
  usersCollection,
  typeProductsCollection,
  productsCollection,
  warehouseCollection,
  numerationCollection,
  suppliersCollection,
  OperationsCollection,
  clientsCollection,
  Coleccion_trabajadores,
  PrivilegesCollection,
  processOperationsCollection,
  documentsOperationsCollection,
  kardexCollection,
  measureUnitCollection,
  generateBd,
  customersCollection,
  storage,
  _storage,
  documentsCollection,
  PaymentsMethodsCollection,
  CurrencyCollection,
  documentTypesCollection,
  salesCollection,
  processSalesCollection,
  Motivos_de_traslado,
  driverCollection,
  transportistaCollection,
  coleccion_partidas_contables,
  numeración_de_documentos,
  coleccion_salidas,
  coleccion_salidas_emitir_comprobante,
  coleccion_salidas_emitir_guia,
  coleccion_cotizaciones,
  Coleccion_cotizacion_provedores,
  coleccion_correo_remitente,
  coleccion_movimientos_contables,
  coleccion_naturaleza_contable,
  coleccion_entradas,
  coleccion_entradas_a_procesar,
  coleccion_credenciales,
  numeracion_de_documentos,
  coleccion_de_libro_diario,
  coleccion_de_periodo_contable,
  coleccion_arreglos,
  coleccion_lista_compras,
  coleccion_ordenes_de_compra,
  coleccion_saldo_inicial,
  colleccion_documentos,
  _firestore,
}